export const getNameString = (test: any) => {
    if (test.name) {
        if (test.name.includes('DTC - ')) {
            return test.name.substring(6, test.name.length);
        }
        return test.name;
    }

    //Keep this here for backwards compatibility
    const oid = typeof test?.oid === 'string' ? test.oid : '';
    const oidPrefix = oid.length >= 10 ? oid.substring(oid.length - 10, oid.length - 8) : '';
    let test_type: string = '';
    const rawTestType = test?.test_type;
    const testTypeToken =
        Array.isArray(rawTestType) && rawTestType.length > 1 && rawTestType[1] != null
            ? String(rawTestType[1])
            : typeof rawTestType === 'string'
              ? rawTestType
              : null;

    if (testTypeToken && testTypeToken.length > 1) {
        const test_arr = testTypeToken.split('-'); //makes array of the words
        for (let i = 0; i < test_arr.length; i++) {
            if (test_arr[i] === 'std')
                test_arr[i] = 'STD'; //makes all of std capital, not just first letter
            else test_arr[i] = test_arr[i][0].toUpperCase() + test_arr[i].substr(1); //makes first letter capital
        }
        test_type = test_arr.join(' '); //joins all the words together into a string, separated by spaces
    }

    //returns what the kits test is
    return oidPrefix === 'CV'
        ? 'Covid-19 RT-PCR Test' //covid tests first
        : oidPrefix === 'AB'
          ? 'Covid-19 Antibody IgG Test'
          : oidPrefix === 'RP'
            ? 'COVID-19 Rapid RT-PCR Test'
            : oidPrefix === 'RA'
              ? 'Rapid COVID-19 Antigen Test'
              : oidPrefix === 'BT'
                ? 'Blood Type Test'
                : oidPrefix === 'CF'
                  ? 'Rapid Flu/COVID 19 Test'
                  : test_type //if it has a test_type attribute, show it
                    ? test_type
                    : test.profile //if it has a profile, show it
                      ? test.profile
                      : oidPrefix === 'AL' //defaults if missing info
                        ? 'Allergy Test'
                        : oidPrefix === 'ST'
                          ? 'STD Test'
                          : Array.isArray(test?.results) && test.results.length > 0 //if its resulted, show its panel name
                            ? test.results[0].panel_name || test.results[0].test_name
                            : oidPrefix === 'BW'
                              ? 'Blood Wellness Test'
                              : `Kit ${oid}`; //if all else fails, shows e.g. Kit AD0112320402
};

export const displayBinaryResultText = (result: string, test_name: string) => {
    //result is 'Positive', 'Negative', 'Detected', etc..
    //This is only for binary results

    switch (test_name) {
        case 'Covid-19 RT-PCR Test':
        case 'Rapid COVID-19 Antigen':
        case 'COVID-19 Rapid RT-PCR':
        case 'COVID-19':
            return `${result} - You are ${result === 'Negative' ? 'not' : ''} actively infected with COVID-19`;
        case 'Flu A':
        case 'Flu B':
            return `${result} - You are ${result === 'Negative' ? 'not' : ''} actively infected with ${test_name}`;
        case 'Covid-19 Total Antibody Test':
        case 'Covid-19 Antibody IgG Test':
            return `${result} - You ${result === 'Negative' ? 'do not' : ''} have antibodies`;
        //if the test_name isn't parsed, just return result text as it came
        default:
            return result;
    }
};
